import { useMutation, useQueryClient } from "@tanstack/react-query";

import { useAuthFetch } from "shared/providers/auth/use-auth-fetch";

import { useUserPreferencesListQueryOptions } from "./use-user-preferences-list-query";

type Params = {
  value: string;
};

type Response = {
  permanent_knowledge: string[];
  lastUpdate: number;
};

export const useAddUserPreferencesMutation = () => {
  const fetch = useAuthFetch();
  const queryClient = useQueryClient();
  const preferencesOptions = useUserPreferencesListQueryOptions();
  return useMutation({
    mutationFn: async (params: Params) => {
      const response = await fetch(
        `${import.meta.env.VITE_BACKEND_URL}/user-preferences`,
        {
          method: "POST",
          body: JSON.stringify({
            value: params.value,
          }),
        }
      );

      const data: Response = await response.json();

      return data;
    },
    onSuccess: () => {
      return queryClient.invalidateQueries({
        queryKey: preferencesOptions.queryKey,
      });
    },
  });
};
